import Link from "next/link";
import { ReactNode } from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import AppBar from "@mui/material/AppBar";
import { ArrowLeft } from "iconsax-react";
import Divider from "@mui/material/Divider";
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { SxProps, useTheme, useMediaQuery } from "@mui/material";

import MuiBreadcrumbs from "../../common/breadcrumbs";

interface Props {
    title?: string;
    children: ReactNode;
    wrapperSx?: SxProps;
    toolbarHref?: string;
    showToolbar?: boolean;
    centerContent?: boolean;
};

const Wrapper = ({ wrapperSx, title, children, toolbarHref, showToolbar, centerContent }: Props) => {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    if (isMobile) {
        return (
            <Box
                sx={{
                    ...wrapperSx,
                    p: 0,
                    minHeight: "calc(100vh - 56px)",
                    display: centerContent ? "flex" : "block",
                    justifyContent: centerContent ? "center" : undefined,
                    alignItems: centerContent ? "center" : undefined,
                }}
            >
                {showToolbar &&
                    <AppBar
                        position="sticky"
                        sx={{
                            background: theme.palette.mode === "dark" ? undefined : "#fff",
                            color: theme.palette.text.primary,
                        }}
                        elevation={0}
                    >
                        <Toolbar sx={{ justifyContent: "space-between" }}>
                            <Typography variant="h5">{title}</Typography>
                            {toolbarHref &&
                                <IconButton color="primary" component={Link} href={toolbarHref}>
                                    <ArrowLeft />
                                </IconButton>
                            }
                        </Toolbar>
                    </AppBar>
                }
                <Box
                    sx={{
                        mt: 1,
                        p: 2,
                        background: theme.palette.mode === "dark" ? "#232424" : "#fff",
                    }}
                >
                    {children}
                </Box>
            </Box>
        );
    };
    return (
        <Container
            sx={{
                ...wrapperSx,
                position: "relative",
                ml: 2,
                minHeight: "90%",
                borderRadius: 4,
                background: theme.palette.mode === "dark" ? "#232424" : "#fff",
            }}
        >
            <Box sx={{ pt: 2, mb: 4 }}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Stack>
                        <Stack direction="row" alignItems="start" spacing={1.5}>
                            <Typography
                                variant="h4"
                                fontWeight="normal"
                                color={theme.palette.mode === "dark" ? "#fff" : "#000"}
                            >
                                {title}
                            </Typography>
                        </Stack>
                        <MuiBreadcrumbs />
                    </Stack>
                </Stack>
                <Divider sx={{ mt: 3 }} />
            </Box>
            {children}
        </Container>
    );
};
export default Wrapper